/* eslint-disable @typescript-eslint/ban-ts-comment */
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
//@ts-ignore
import { createRoot } from 'react-dom/client';

import './css/bootstrap-negative-margins.min.css';
// @ts-ignore
import 'bootstrap';
import 'bootstrap/js/dist/util';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet/dist/leaflet.css';

import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './global.style.less';
import './css/main.css';
import './css/theme.css';

const root = createRoot(document.getElementById('app') as HTMLElement);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
);
